export enum ReportStatus {
  DRAFT = "DRAFT",
  PENDING = "PENDING",
  STARTED = "STARTED",
  EXTRACTING = "EXTRACTING",
  GENERATING = "GENERATING",
  PENDING_REVIEW = "PENDING REVIEW",
  AWAITING_INPUT = "AWAITING INPUT",
  // Some (not all) videos failed transcription — the user must continue
  // without them or cancel the report. See ReportJobStatus for the rationale.
  AWAITING_TRANSCRIPT_DECISION = "AWAITING TRANSCRIPT DECISION",
  IN_CO_REVIEW = "IN CO REVIEW",
  CHANGES_REQUESTED = "CHANGES REQUESTED",
  CO_APPROVED = "CO APPROVED",
  SUBMITTED = "SUBMITTED",
  SIGNED = "SIGNED",
  RMS_COMMITTED = "RMS COMMITTED",
  FAILED = "FAILED",
}
